import { KeyboardEvent, useEffect, useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";
import { Content_SYS4010_R01 } from "./Content_SYS4010_R01";
import { Info_SYS4010_R01 } from "./Info_SYS4010_R01";
import { SearchSection_SYS4010_R01 } from "./SearchSection_SYS4010_R01";
import { useSYS4010_R01Store } from "./Store_SYS4010_R01";
import { Table_SYS4010_R01 } from "./Table_SYS4010_R01";
import { SYS4010_R01Dto } from "./Dto_SYS4010_R01";
import { AgGridReact } from "ag-grid-react";

export const Container_SYS4010_R01 = () => {

	const {
		setSYS4010_R01List,
		selectedSYS4010_R01, setSelectedSYS4010_R01,
		editSYS4010_R01, setEditSYS4010_R01,
		allCount,
		initData,
	} = useSYS4010_R01Store();
	
	const { setMessage } = useUiuxStore();
	

	// 버튼 비활성화 상태 관리
	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,
		create: false,
		delete: true,
		save: true,
		print: true,
		excel: true,
		init: false
	});

	// 선택된 회사가 변경될 때 버튼 상태 업데이트
	useEffect(() => {
		setButtonDisabled(prev => ({
			...prev,
			delete: !selectedSYS4010_R01,
			save: !selectedSYS4010_R01 && !editSYS4010_R01.compCd,
			print: !selectedSYS4010_R01,
			excel: !selectedSYS4010_R01
		}));
	}, [selectedSYS4010_R01, editSYS4010_R01]);

	const RESIZER = {
		code: 'SYS4010_R01',
		type: 'height',
		storageKey: 'company-split-height',
		min: 5,
		max: 80,
		default: 39
	} as const;
	const gridRef = useRef<AgGridReact<SYS4010_R01Dto>>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef,
	});


	const {
		handleExcelClick,
		handleCompNmChange,
		fetchData,
		defaultSYS4010_R01Row,
		fetchOne,
		initContainerData,
		handleCreateClick,
		handleSaveClick,
		handleDeleteClick,
	} = Content_SYS4010_R01({  
		gridRef,
		setMessage,
	});

	


	return <div className="content-container">
    <Actionbar
		onFetchClick={fetchData}
		onCreateClick={handleCreateClick}
		onDeleteClick={handleDeleteClick}
		onSaveClick={handleSaveClick}
		onExcelClick={handleExcelClick}
		onInitClick={initContainerData}
    />
    <SearchSection_SYS4010_R01 onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
			if (e.key === 'Enter') {
				fetchData()
			}
		}} />
    <div className="flex flex-1 flex-col px-[12px] gap-[4px] overflow-x-auto p-[10px]" ref={containerRef}>
		<div className="w-full" style={{ height: `${splitValue}%` }}>
        	<Info_SYS4010_R01 data={selectedSYS4010_R01} defaultSYS4010_R01Row={defaultSYS4010_R01Row()} />
		</div>
      {/* 리사이저 */}
		<div
        className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
        onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown("UD", e.nativeEvent) }
		// 드래그 시작 방지
		onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
		/>
		<div className="w-full " style={{ height: `${100 - splitValue}%` }}>
        	<Table_SYS4010_R01 gridRef={gridRef} defaultSYS4010_R01Row={defaultSYS4010_R01Row()} />
		</div>
    </div>
    <Message />
	</div>
}